export var PHONE_NUMBER_PATTERN = /^\(?[2-9]([0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
export var PHONE_EXTENSION_PATTERN = /^(\d\d\d\d|\d\d\d)$/;
export var PHONE_CAPTURING_GROUPS = /(\d{3})(\d{3})(\d*)/;
//# sourceMappingURL=phone.js.map